export default {
  allLocations: []
}



// WEBPACK FOOTER //
// ./src/modules/location/store/state.js